// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "./channels/consumer"

// Must be imported before any module that expects a global jQuery (bootstrap, datatables, etc.)
import $ from "jquery"
window.$ = window.jQuery = $

import Popper from "popper.js"
window.Popper = Popper

import "bootstrap/dist/js/bootstrap"

// datatables.net-bs4 exports a factory that must be invoked with (window, $) to attach itself
import DataTablesBS4 from "datatables.net-bs4"
DataTablesBS4(window, $)

Rails.start()
ActiveStorage.start()

document.addEventListener("turbo:load", function() {
  $('#primaryTable').DataTable();
});